import React, { useState } from 'react';

import arrowDownIcon from '../../assets/images/icon/arrow_down_fill.png';

type Props = {
	children: React.ReactNode
	label: string
};

function ToggleField({ label, children }: Props) {
	const [active, setActive] = useState(false);
	
	const onToggle = () => {
		setActive(!active);
	}

	return (
		<div className={active ? 'basic-toggle-field active' : 'basic-toggle-field'}>
			<header 
				className="basic-toggle-field-header"
				onClick={onToggle}
			>
				<img src={arrowDownIcon} alt="toggle" width="10" />
				{label}
			</header>
			<div className="basic-toggle-field-body">
				{children}
			</div>
		</div>
	);
}

export default ToggleField;